<span class="title">{{ data.title }}</span>
<div class="mat-simple-snackbar-action action">
  <button mat-button (click)="data.callback()" [disabled]="callingBack">
    {{ data.action }}{{ remainingTime }}
  </button>
</div>
